export default __webpack_public_path__ + "static/235-34e0c56bffe6c3d549f37b315cba771d.jpg";